const CLAIMS = {
  id: ["nameidentifier", "UserId", "sub", "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"],
  nome: ["name", "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"],
  email: ["email", "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"],
  fotoUrl: ["FotoUrl"],
  entidadeId: ["EntidadeId"],
  unidadeId: ["UnidadeId"],
  perfilId: ["PerfilId"],
  tipoUsuario: ["TipoUsuario", "role", "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"],
  versaoSistemaId: ["VersaoSistemaId"],
};

const contextValue = (value) => value === undefined || value === null || value === "" ? null : String(value);

export const hasChangedAuthScope = (previous, current) =>
  ["entidadeId", "unidadeId", "perfilId"].some(
    (field) => contextValue(previous[field]) !== contextValue(current[field])
  );

// JwtService and TokenService emit different claim names. Always prefer the
// token's context over the previously saved user or the selection response.
export const userFromTokenClaims = (decoded, previous = {}, context = {}) => {
  const claims = Object.fromEntries(Object.entries(decoded).map(([key, value]) => [key.toLowerCase(), value]));
  const user = { ...previous };

  for (const [field, aliases] of Object.entries(CLAIMS)) {
    const key = aliases.map((alias) => alias.toLowerCase()).find((alias) => Object.prototype.hasOwnProperty.call(claims, alias));
    if (key !== undefined) {
      user[field] = field.endsWith("Id") ? contextValue(claims[key]) : claims[key];
    } else if (["perfilId", "versaoSistemaId"].includes(field) && Object.prototype.hasOwnProperty.call(context, field)) {
      user[field] = contextValue(context[field]);
    }
  }

  if (user.tipoUsuario) user.tipoUsuario = String(user.tipoUsuario).trim().toLowerCase();

  const changedLocation = ["entidadeId", "unidadeId"].some(
    (field) => contextValue(previous[field]) !== contextValue(user[field])
  );
  if (changedLocation && !Object.prototype.hasOwnProperty.call(claims, "versaosistemaid") &&
      !Object.prototype.hasOwnProperty.call(context, "versaoSistemaId")) {
    user.versaoSistemaId = null;
  }

  return user;
};
